<template>
  <div
    :class="[
      'lad-landing-book-now__custom',
      open ? 'book-now__dialog-open' : '',
    ]"
  >
    <div v-if="hasPrice" class="price-wrapper--custom">
      <div class="content-info-discount">
        <div>
          <el-tag
            v-if="showMSI"
            type="success"
            effect="plain"
            size="mini"
            class="reserve-with--msi"
          >
            {{ $t(`${base}.msi`) }}
          </el-tag>

          <el-tag
            v-if="_hasDiscount"
            type="success"
            effect="plain"
            size="mini"
            class="reserve-with--msi"
          >
            {{ _promoDiscount }}
          </el-tag>
        </div>

        <div v-if="_hasDiscount" class="price-with-promotions">
          <div
            v-if="showPerPerson || hasDateRestriction"
            class="container-before"
            ><span class="price-before">{{
              `${symbol}${withoutDiscount}`
            }}</span>
          </div>
        </div>
      </div>

      <div class="price-row-wrapper--custom">
        <p
          class="full-price"
          :class="{ 'full-price-with-promotions': _hasDiscount }"
        >
          <span class="symbol">{{ symbol }}</span>
          <span class="price">{{ amount }}</span>
          <span class="decimal">{{ `${decimal}${cents}` }}</span>
          <span class="currency">{{ `${currency}` }}</span>

          <br v-if="!isMobile" />

          <span
            v-if="showPerPerson || hasDateRestriction"
            class="total-price-per-person"
            >{{ $t(`${base}.per_person`) }}</span
          >
          <span v-else class="total-price-per-person">{{
            $t(`${base}.total_price_per_person_${promoType}`)
          }}</span>
        </p>
      </div>

      <p class="reserve-with-and-pay">{{
        $t(`${base}.reserve_with_and_pay`, {
          value: _layaway,
        })
      }}</p>

      <el-button class="cta-reserve-with-and-pay" @click="goToDates">
        {{
          $t(
            `general.landings.${
              abtesting === 'gnrl3' && isLad ? 'see_dates' : 'reserve_now'
              // eslint-disable-next-line vue/comma-dangle
            }`
          )
        }}
      </el-button>
    </div>
    <div v-else class="price-wrapper--custom">
      <el-button class="cta-reserve-with-and-pay" @click="open = true">{{
        $t('route.i_want_to_quote')
      }}</el-button>
    </div>

    <LadDialog
      v-if="open"
      :visible="open"
      :handle-before-close="handleClose"
      class="lad-landing-book-now__custom--dialog"
    >
      <template slot="dialog-header">
        <span>&nbsp;</span>
      </template>

      <template slot="dialog-body">
        <LadZohoFormLead @submitted="handleSubmitted">
          <LadFacebookWidget
            v-if="submitted"
            slot="sent"
            :group-id="exExperience.facebook_group_id"
          />
        </LadZohoFormLead>
      </template>

      <template slot="dialog-footer">
        <el-button @click="handleClose">{{ $t('general.close') }}</el-button>
      </template>
    </LadDialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import LadPricePromoMixin from '@/components/frontends/Price/components/mixin/promo'

export default {
  name: 'LadLandingBookNowCustom',
  components: {
    LadDialog: () =>
      import(
        /* webpackChunkName: "lad-dialog" */ '@/components/frontends/Modal/index'
      ),
    LadZohoFormLead: () =>
      import(
        /* webpackChunkName: "lad-zoho-form--lead" */ '@/components/zoho-form/lead'
      ),
    LadFacebookWidget: () =>
      import(
        /* webpackChunkName: "lad-face-widget" */ '@/components/facebook/widget'
      ),
  },
  mixins: [LadPricePromoMixin],
  props: {
    externalPrice: { type: Number, required: false, default: 0 },
    abtesting: { type: String, required: false, default: null },
  },
  data() {
    return {
      base: 'experience.price',
      symbol: '$',
      open: false,
      submitted: false,
    }
  },
  computed: {
    ...mapState('experience', {
      promotions: 'promotions',
      isLad: (state) => state.experience.is_lad,
      totalAmount: (state) => state.sales_plan.total_amount,
      layawayAmount: (state) => state.sales_plan.layaway_amount,
      exExperience: (state) => ({
        facebook_group_id: state.experience.facebook_group_id,
      }),
    }),
    ...mapState('availability', {
      hasAvailability: (state) => state.exist,
      item: (state) => {
        let items = []

        state.availability.ranges.forEach((range) => {
          range.items.forEach((t) => {
            t.availability
              .filter((t) => t.min_travelers === null || t.min_travelers === 1)
              .forEach((a) => items.push(a))
          })
        })

        items = items.sort((a, b) => b.price - a.price)

        return items.length > 0
          ? items[0]
          : {
              layaway: null,
              price: null,
              liquidate_before: null,
              datetime: { start: null, end: null },
            }
      },
    }),
    ...mapState('settings', ['currency']),
    ...mapGetters('device', ['isMobile']),
    /** meses sin intereses */
    showMSI() {
      const range = process.env.EBANX_MSI_DATE_RANGE.split(',')
      const start = this.$dayjs(range[0]).startOf('day')
      const end = this.$dayjs(range[1]).endOf('day')
      const currencies = process.env.EBANX_MSI_CURRENCY.split(',')

      const inRange = this.$dayjs().isBetween(start, end, null, '[]')

      /** revisar `components/payment-methods/components/card.vue` en caso de cambios con currency */
      return inRange && currencies.includes(this.currency)
    },
    // TODO: this is necessary to section price
    reserveWith() {
      return this.$options.filters.ladFnCurrency(
        this.layawayAmount,
        this.currency
      )
    },
    showPerPerson() {
      return !(
        this.promoType.startsWith('promo_2x1') ||
        this.promoType.startsWith('promo_3x1')
      )
    },
    hasDateRestriction() {
      return this.promoType.endsWith('_dates') && !this.showDiscountOrPromo
    },
    _hasDiscount() {
      return (
        this.hasDiscount || (!this.showPerPerson && !this.hasDateRestriction)
      )
    },
    youSaveWithFormat() {
      let value = 0
      if (this._hasDiscount) {
        switch (true) {
          case this.promoType.startsWith('promo_2x1'):
            value = this.$options.filters.ladFnCurrency(
              this.price,
              this.currency,
              true,
              ''
            )
            break

          case this.promoType.startsWith('promo_3x1'):
            value = this.$options.filters.ladFnCurrency(
              this.price * 2,
              this.currency,
              true,
              ''
            )
            break

          default:
            value = this.discountWithFormat
            break
        }
      }

      return value
    },
    hasPrice() {
      return parseFloat(this.externalPrice || this.totalAmount) > 0
    },
    price() {
      return this.externalPrice || this.totalAmount
    },
    amountCurrency() {
      return this.$options.filters
        .ladFnCurrency(this.price, this.currency, false)
        .subtract(this.discountAmount)
    },
    amountWithoutFormat() {
      return this.amountCurrency.format(false).replace(this.symbol, '')
    },
    amount() {
      return this.showZeroPrice && this.amountCurrency.dollars() === 0
        ? '-'
        : this.amountWithoutFormat.slice(0, -3)
    },
    cents() {
      const length = this.amountWithoutFormat.length

      return this.amount === '-' && this.amountCurrency.cents() === 0
        ? '--'
        : this.amountWithoutFormat.slice(-2, length)
    },
    decimal() {
      return this.amountCurrency.s.decimal
    },
    _promoDiscount() {
      let promoDiscount = ''
      if (this._hasDiscount) {
        switch (true) {
          case this.promoType.startsWith('promo_2x1'):
            promoDiscount = '2x1'
            break

          case this.promoType.startsWith('promo_3x1'):
            promoDiscount = '3x1'
            break

          default:
            promoDiscount = this.promoDiscount
            break
        }
      }

      return promoDiscount
    },
    _layaway() {
      return this.$options.filters.ladFnCurrency(
        this.item.layaway || this.layawayAmount,
        this.currency
      )
    },
  },
  methods: {
    handleClose() {
      this.open = false
    },
    handleSubmitted() {
      this.submitted = true
    },
    goToDates() {
      if (this.abtesting === 'gnrl3' && this.isLad && this.hasAvailability) {
        this.$emit('go-to-dates')
        return
      }

      if (this.isMobile) {
        this.open = true
      } else {
        this.$emit('go-to-form')
      }
    },
  },
}
</script>

<style lang="scss">
.lad-landing-book-now {
  &__custom {
    background-color: #fff;
    padding: 16px 20px;
    top: unset !important;
    bottom: 0;

    .price-wrapper--custom {
      display: grid;
      gap: 16px;

      @media (min-width: 768px) {
        padding: 20px;
        border: 1px solid #ccc;
        border-radius: 8px;
      }

      .wrapper-msi-promotion {
        .discount-value {
          border-radius: 10px;
          border: 1px solid rgba(201, 24, 0, 0.3);
          padding: 3px 5.3px 3px 6px;

          span {
            color: #c91800;
            font-size: 11.2px;
            font-style: normal;
            font-weight: 700;
            line-height: 12.88px; /* 115% */
          }
        }
      }

      .price-with-promotions {
        margin: 0;

        .container-before,
        .container-you-save {
          display: inline-block;
          color: #909399;
          font-size: 11.2px;
          font-style: normal;
          font-weight: 400;
          line-height: 12.88px; /* 115% */
          text-transform: capitalize;

          .price-before {
            font-size: 14px;
            font-weight: 700;
            text-decoration: line-through;
          }

          .price-you-save {
            color: #1aa31c;
            font-size: 14px;
            font-weight: 500;
          }
        }

        .container-before {
          margin-right: 10px;
        }

        .container-you-save {
          border-radius: 50px;
          border: 1.5px solid rgba(50, 152, 0, 0.3);
          padding: 4px 12px;
        }
      }

      .price-with-promo-type {
        // margin-top: 10px;

        .container-promo-type {
          display: inline-block;
          color: black;
          font-size: 11.2px;
          font-style: normal;
          font-weight: 400;
          line-height: 12.88px; /* 115% */
          text-transform: capitalize;
          border-radius: 50px;
          border: 1px solid rgba(201, 24, 0, 0.3);
          padding: 4px 12px;

          .price-promo-type {
            color: #c91800;
            font-size: 14px;
            font-weight: 500;
          }
        }
      }

      .full-price {
        margin: 0;

        .symbol,
        .price,
        .decimal,
        .currency {
          font-size: 30px;
          font-weight: 700;
        }

        .currency {
          font-size: 14px;
        }

        &-with-promotions {
          .symbol,
          .price,
          .decimal,
          .currency {
            color: #1aa31c;
          }
        }
      }

      .total-price-per-person {
        margin: 0;
        color: #000;
        font-size: 15.2px;
        font-style: normal;
        font-weight: 700;
        line-height: 12.88px; /* 84.737% */

        @media screen and (min-width: 768px) {
          line-height: 24px;
        }
      }

      .reserve-with-and-pay {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: #000;
        margin: 0;
      }

      .cta-reserve-with-and-pay {
        width: 100%;
        border: unset;
        background-color: #1d72af;
        color: #fff;
        padding: 16px;
        font-size: 16px;
        font-weight: 500;
        line-height: 14px;
      }

      .reserve-with {
        display: none;
        color: #000;
        font-size: 15.2px;
        font-style: normal;
        font-weight: 400;
        line-height: 12.88px; /* 84.737% */

        &--price {
          font-weight: 700;
        }

        &--msi {
          border-radius: 50px;
          border: 1.5px solid #1aa31c;
          color: #1aa31c;
          font-size: 11.2px;
          font-weight: 700;
        }
      }

      .content-info-discount {
        display: grid;
        grid-template-columns: max-content 1fr;
        align-items: center;
        gap: 10px;
      }
    }

    &.affix {
      z-index: 2000 !important;
      &.book-now__dialog-open {
        z-index: 2015 !important;
      }

      .content-info-discount {
        display: none;
      }
    }

    &--dialog {
      .lad-zoho {
        &--header {
          padding: 0;
        }

        .el-main {
          padding: 0;
        }
      }
    }
  }
}
</style>
